export function canSwitchMode(mode) {
    return true;
}
//# sourceMappingURL=view-mode.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-bootstrap/datepicker/engine/view-mode.js
// module id = ./node_modules/ngx-bootstrap/datepicker/engine/view-mode.js
// module chunks = common